<template>
  <ProductSeriesPage
    :title="title"
    :title-lines="titleLines"
    :subtitle="subtitle"
    :hero-image="heroImage"
    :hero-copy-class="heroCopyClass"
    :hero-title-class="heroTitleClass"
    :items="items"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ProductSeriesPage from '@/components/ProductSeriesPage.vue'

import heroImage from '@/assets/images/pixso-industry-official/positioning-series.jpg'
import i10Image from '@/assets/images/pixso-industry-official/i10.png'
import ix10Image from '@/assets/images/pixso-industry-official/ix10.png'
import p100aImage from '@/assets/images/pixso-industry-official/p100a.png'
import p200aImage from '@/assets/images/pixso-industry-official/p200a.png'

const { locale, t, tm } = useI18n()

const title = computed(() => t('IndustryPositioningSeries.title'))
const subtitle = computed(() => '')
const titleLines = computed(() => {
  const lines = tm('IndustryPositioningSeries.titleLines')
  return Array.isArray(lines) ? lines : []
})
const isEnglish = computed(() => locale.value.startsWith('en'))
const heroCopyClass = computed(() => (
  isEnglish.value ? 'product-series__hero-copy--wide-title' : ''
))
const heroTitleClass = computed(() => (
  isEnglish.value ? 'product-series__hero-title--balanced-two-line' : ''
))

const items = computed(() => [
  {
    title: t('IndustryPositioningSeries.cards.p100a.title'),
    description: t('IndustryPositioningSeries.cards.p100a.desc'),
    image: p100aImage,
    to: '/product/industry/positioning/p100a'
  },
  {
    title: t('IndustryPositioningSeries.cards.p200a.title'),
    description: t('IndustryPositioningSeries.cards.p200a.desc'),
    image: p200aImage,
    to: '/product/industry/positioning/p200a'
  },
  {
    title: t('IndustryPositioningSeries.cards.i10.title'),
    description: t('IndustryPositioningSeries.cards.i10.desc'),
    image: i10Image,
    to: '/product/industry/positioning/i10'
  },
  {
    title: t('IndustryPositioningSeries.cards.ix10.title'),
    description: t('IndustryPositioningSeries.cards.ix10.desc'),
    image: ix10Image,
    to: '/product/industry/positioning/ix10'
  }
])
</script>
